module.exports = __webpack_public_path__ + "img/left-arrow.87e27296.svg";